"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profilePlus = exports.profilePicture = exports.BlockAction = exports.UserAccount = exports.enabledLocationServices = exports.enabledNotifications = exports.profileSetupComplete = exports.hasLoveLanguage5 = exports.hasLoveLanguage4 = exports.hasLoveLanguage3 = exports.hasLoveLanguage2 = exports.hasLoveLanguage1 = exports.hasSpiritualJourney = exports.hasPersonalityType = exports.hasChineseZodiac = exports.hasMayanAstrology = exports.hasSacredText = exports.hasSpiritualPractice = exports.hasCoreValue = exports.hasSystemIdeology = exports.hasBelief = exports.hasPassion = exports.workoutFrequency = exports.fourTwentyFriendly = exports.drinkFrequency = exports.smokingHabit = exports._self = exports.ns = exports.loadData = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
//import all the exports of this file as one variable called _this (we need this at the end)
const _this = __importStar(require("./profile-plus"));
/**
 * Load the data of this ontology into memory, thus adding the properties of the entities of this ontology to the local graph.
 */
var loadData = () => {
    return Promise.resolve().then(() => __importStar(require('../data/profile-plus.json'))).then((data) => JSONLD_1.JSONLD.parse(data));
};
exports.loadData = loadData;
/**
 * The namespace of this ontology, which can be used to create NamedNodes with URI's not listed in this file
 */
exports.ns = (0, NameSpace_1.createNameSpace)('http://lincd.org/ont/profile-plus/');
/**
 * The NamedNode of the ontology itself
 */
exports._self = (0, exports.ns)('');
//A list of all the entities (Classes & Properties) of this ontology, each exported as a NamedNode
exports.smokingHabit = (0, exports.ns)('smokingHabit');
exports.drinkFrequency = (0, exports.ns)('drinkFrequency');
exports.fourTwentyFriendly = (0, exports.ns)('fourTwentyFriendly');
exports.workoutFrequency = (0, exports.ns)('workoutFrequency');
exports.hasPassion = (0, exports.ns)('hasPassion');
exports.hasBelief = (0, exports.ns)('hasBelief');
exports.hasSystemIdeology = (0, exports.ns)('hasSystemIdeology');
exports.hasCoreValue = (0, exports.ns)('hasCoreValue');
exports.hasSpiritualPractice = (0, exports.ns)('hasSpiritualPractice');
exports.hasSacredText = (0, exports.ns)('hasSacredText');
exports.hasMayanAstrology = (0, exports.ns)('hasMayanAstrology');
exports.hasChineseZodiac = (0, exports.ns)('hasChineseZodiac');
exports.hasPersonalityType = (0, exports.ns)('hasPersonalityType');
exports.hasSpiritualJourney = (0, exports.ns)('hasSpiritualJourney');
exports.hasLoveLanguage1 = (0, exports.ns)('hasLoveLanguage1');
exports.hasLoveLanguage2 = (0, exports.ns)('hasLoveLanguage2');
exports.hasLoveLanguage3 = (0, exports.ns)('hasLoveLanguage3');
exports.hasLoveLanguage4 = (0, exports.ns)('hasLoveLanguage4');
exports.hasLoveLanguage5 = (0, exports.ns)('hasLoveLanguage5');
exports.profileSetupComplete = (0, exports.ns)('profileSetupComplete');
exports.enabledNotifications = (0, exports.ns)('enabledNotifications');
exports.enabledLocationServices = (0, exports.ns)('enabledLocationServices');
exports.UserAccount = (0, exports.ns)('UserAccount');
exports.BlockAction = (0, exports.ns)('BlockAction');
exports.profilePicture = (0, exports.ns)('profilePicture');
//An extra grouping object so all the entities can be accessed from the prefix/name
exports.profilePlus = {
    smokingHabit: exports.smokingHabit,
    drinkFrequency: exports.drinkFrequency,
    fourTwentyFriendly: exports.fourTwentyFriendly,
    workoutFrequency: exports.workoutFrequency,
    hasPassion: exports.hasPassion,
    hasBelief: exports.hasBelief,
    hasSystemIdeology: exports.hasSystemIdeology,
    hasCoreValue: exports.hasCoreValue,
    hasSpiritualPractice: exports.hasSpiritualPractice,
    hasSacredText: exports.hasSacredText,
    hasMayanAstrology: exports.hasMayanAstrology,
    hasChineseZodiac: exports.hasChineseZodiac,
    hasPersonalityType: exports.hasPersonalityType,
    hasLoveLanguage1: exports.hasLoveLanguage1,
    hasLoveLanguage2: exports.hasLoveLanguage2,
    hasLoveLanguage3: exports.hasLoveLanguage3,
    hasLoveLanguage4: exports.hasLoveLanguage4,
    hasLoveLanguage5: exports.hasLoveLanguage5,
    hasSpiritualJourney: exports.hasSpiritualJourney,
    profileSetupComplete: exports.profileSetupComplete,
    enabledNotifications: exports.enabledNotifications,
    enabledLocationServices: exports.enabledLocationServices,
    UserAccount: exports.UserAccount,
    BlockAction: exports.BlockAction,
    profilePicture: exports.profilePicture,
};
//Registers this ontology to LINCD.JS, so that data loading can be automated amongst other things
(0, package_1.linkedOntology)(_this, exports.ns, 'profile-plus', exports.loadData, '../data/profile-plus.json');
//# sourceMappingURL=profile-plus.js.map